export default "__VITE_ASSET__DcABAYUH__"